<div *ngIf="loading" style="margin-top: 64px;display: flex;justify-content: center;">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
    </p-progressSpinner>
</div>

<div class="container-fluid" *ngIf="!loading">
    <div>
        <div class="margin-top-8">
            <div class="header">
                {{partner.name}}
            </div>
        </div>

        <div class="row">
            <div class="col-md-3 label">Customers Stripe ID:</div>
            <div class="col-md-3"><input type="text" pInputText [(ngModel)]="partnerStatus.stripID" /></div>
            <div class="col-md-6 flex label"><small>This would normally begin with a "cus_XXXXXXXXX"</small></div>
        </div>

        <div class="row margin-top-8">
            <div class="col-md-3 label">Stripe Subscription ID:</div>
            <div class="col-md-3"><input type="text" pInputText [(ngModel)]="partnerStatus.bikeShopSubscriptionId" />
            </div>
            <div class="col-md-6 flex label"><small>This would normally begin with a "sub_XXXXXXXXX"</small></div>
        </div>
        <div class="row margin-top-8">
            <div class="col-md-12 flex label"><small>The above are only nessassary if this account is linked to a Stripe
                    subscription. Why is this nessassary... when things happen in Stripe, like a cancellation or missed
                    payment, Stripe can send Hubtiger notifications and if the Stripe information is linked to a Store,
                    we can show these statuses in Hubtiger and cancel subscriptions when they cancelled in
                    Stripe</small></div>
        </div>



        <div class="info-container content margin-top-16">
            <div class="container-header">Workshop</div>
            <div *ngIf="partnerStatus.workShopPlan.id === undefined" class="row margin-bottom-16">
                <div class="col-md-3 label">Add Workshop access to store:</div>
                <div class="col-md-3 label"><p-inputSwitch [(ngModel)]="showWorkshopSubscription"></p-inputSwitch></div>
            </div>
            <div *ngIf="partnerStatus.workShopPlan.id !== undefined || showWorkshopSubscription">
                <div class="row">
                    <div class="col-md-3 label"></div>
                    <div class="col-md-3 label bold">Subscribed Product</div>
                    <div class="col-md-3 label bold">Store Status</div>
                    <div class="col-md-3 label bold" *ngIf="partnerStatus.workShopPlan.statusID == 1">Trial End Date
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 label"
                    [ngClass]="{'red bold': (partnerStatus.workShopPlan.stripeProductID && !partnerStatus.workShopPlan.statusID) || (partnerStatus.workShopPlan.stripeProductID && partnerStatus.workShopPlan.statusID === 1 && !partnerStatus.workShopPlan.trialEnds)}">Subscription Status:</div>
                    <div class="col-md-3"><p-dropdown [options]="workshopProductPlans"
                            [(ngModel)]="partnerStatus.workShopPlan.stripeProductID"></p-dropdown></div>
                    <div class="col-md-3"><p-dropdown [options]="statuses"
                            [(ngModel)]="partnerStatus.workShopPlan.statusID"></p-dropdown></div>
                    <div class="col-md-3" *ngIf="partnerStatus.workShopPlan.statusID == 1"><p-calendar [minDate]="today"
                            [(ngModel)]="partnerStatus.workShopPlan.trialEnds"
                            [disabled]="partnerStatus.workShopPlan.statusID != 1"></p-calendar></div>
                </div>
                <div class="row margin-top-8">
                    <div class="col-md-3 label"># Technicians Override:</div>
                    <div class="col-md-3"><input type="number" pInputText
                            [(ngModel)]="partnerStatus.workShopPlan.techniciansAllowedOverride" [min]="0" [max]="100" />
                    </div>
                    <div class="col-md-6 flex label"><small>0 - 100 Technitions. ONLY USE THIS IF YOU WANT TO OVERRIDE
                            THE DEFAULT SUBSCRIPTION AMOUNT</small></div>
                </div>
                <div class="row margin-top-8">
                    <div class="col-md-3 label">Monthly SMS's Override:</div>
                    <div class="col-md-3"><input type="number" pInputText
                            [(ngModel)]="partnerStatus.workShopPlan.manualSMSAllocation" [min]="0" [max]="10000" />
                    </div>
                    <div class="col-md-6 flex label"><small>0 - 10000 SMS's. ONLY USE THIS IF YOU WANT TO OVERRIDE THE
                            DEFAULT SUBSCRIPTION AMOUNT</small></div>
                </div>
            </div>

        </div>

        <div class="info-container content margin-top-16">
            <div class="container-header">Rentals</div>

            <div *ngIf="partnerStatus.rentalPlan.id === undefined" class="row margin-bottom-16">
                <div class="col-md-3 label">Add Rentals access to store:</div>
                <div class="col-md-3 label"><p-inputSwitch [(ngModel)]="showRentalsSubscription"></p-inputSwitch></div>
            </div>
            <div *ngIf="partnerStatus.rentalPlan.id !== undefined || showRentalsSubscription">
                <div class="row">
                    <div class="col-md-3 label"></div>
                    <div class="col-md-3 label bold">Subscribed Product</div>
                    <div class="col-md-3 label bold">Store Status</div>
                    <div class="col-md-3 label bold" *ngIf="partnerStatus.rentalPlan.statusID == 1">Trial End Date</div>
                </div>
                <div class="row">
                    <div class="col-md-3 label" [ngClass]="{'red bold': (partnerStatus.rentalPlan.stripeProductID && !partnerStatus.rentalPlan.statusID) || (partnerStatus.rentalPlan.stripeProductID && partnerStatus.rentalPlan.statusID === 1 && !partnerStatus.rentalPlan.trialEnds)}">Subscription Status:</div>
                    <div class="col-md-3"><p-dropdown [options]="rentalProductPlans"
                            [(ngModel)]="partnerStatus.rentalPlan.stripeProductID"></p-dropdown></div>
                    <div class="col-md-3"><p-dropdown [options]="statuses"
                            [(ngModel)]="partnerStatus.rentalPlan.statusID"></p-dropdown></div>
                    <div class="col-md-3" *ngIf="partnerStatus.rentalPlan.statusID == 1"><p-calendar [minDate]="today"
                            [(ngModel)]="partnerStatus.rentalPlan.trialEnds"
                            [disabled]="partnerStatus.rentalPlan.statusID != 1"></p-calendar></div>
                </div>
                <div class="row margin-top-8">
                    <div class="col-md-3 label"># Rental Products Override:</div>
                    <div class="col-md-3"><input type="number" pInputText
                            [(ngModel)]="partnerStatus.rentalPlan.maxNumberRentalItesmOverride" [min]="0" [max]="1000" />
                    </div>
                    <div class="col-md-6 flex label"><small>0 - 1000 Products. ONLY USE THIS IF YOU WANT TO OVERRIDE THE
                            DEFAULT SUBSCRIPTION AMOUNT</small></div>
                </div>
            </div>
        </div>

        <div class="info-container content margin-top-16">
            <div class="container-header">Whastapp</div>

            <div *ngIf="partnerStatus.whatsappPlan.id === undefined" class="row margin-bottom-16">
                <div class="col-md-3 label">Add Whatsapp to store:</div>
                <div class="col-md-3 label"><p-inputSwitch [(ngModel)]="showWhatsappSubscription"></p-inputSwitch></div>
            </div>
            <div *ngIf="partnerStatus.whatsappPlan.id !== undefined || showWhatsappSubscription">
                <div class="row">
                    <div class="col-md-3 label"></div>
                    <div class="col-md-3 label bold">Subscribed Product</div>
                    <div class="col-md-3 label bold">Store Status</div>
                    <div class="col-md-3 label bold" *ngIf="partnerStatus.whatsappPlan.statusID == 1">Trial End Date</div>
                </div>
                <div class="row">
                    <div class="col-md-3 label" [ngClass]="{'red bold': (partnerStatus.whatsappPlan.stripeProductID && !partnerStatus.whatsappPlan.statusID) || (partnerStatus.whatsappPlan.stripeProductID && partnerStatus.whatsappPlan.statusID === 1 && !partnerStatus.whatsappPlan.trialEnds)}">Subscription Status:</div>
                    <div class="col-md-3"><p-dropdown [options]="whatsappProductPlans"
                            [(ngModel)]="partnerStatus.whatsappPlan.stripeProductID"></p-dropdown></div>
                    <div class="col-md-3"><p-dropdown [options]="whatsappStatuses"
                            [(ngModel)]="partnerStatus.whatsappPlan.statusID"></p-dropdown></div>
                    <div class="col-md-3" *ngIf="partnerStatus.whatsappPlan.statusID == 1"><p-calendar [minDate]="today"
                            [(ngModel)]="partnerStatus.whatsappPlan.trialEnds"
                            [disabled]="partnerStatus.whatsappPlan.statusID != 1"></p-calendar></div>
                </div>
            </div>
        </div>

        <div class="row margin-top-16">
            <div class="col-md-8"></div>
            <div class="col-md-4"><button pButton class="full-width" label="Save Subscription Changes"
                (click)="updateSubscription()"
                [disabled]="!valid() || savingChanges"></button></div>
        </div>
        <div class="row margin-top-8" *ngIf="changesSaved">
            <div class="col-md-12 bold red">Your changes have been saved....</div>
        </div>

    </div>
</div>